export class WithdrawalMethodOut {
    type: string = "MOBILE_MONEY"
    operator_id: string = "orange_money"
    identifier: string = ""
}
